import { values } from 'lodash/fp';
import pairedMap from './pairedMap';

export default (config, checkersByName) =>
  pairedMap(([featureName, criteria]) => {
    const checkers = pairedMap(([checkerName, args]) => {
      const checker = checkersByName[checkerName];

      if (!checker) {
        throw new Error(`Feature checker "${checkerName}" is not defined!`);
      }

      return [checkerName, checker(featureName, args)];
    }, criteria);

    return [featureName, values(checkers)];
  }, config);
